module.exports = __webpack_public_path__ + "img/background-program.30ecb023.svg";